// extracted by mini-css-extract-plugin
export default {"mobile-tab-names":"wr","active":"xr","mobile-nav-container":"yr","upper-column":"zr","profile-mobile-nav":"Ar","secondary-menu-link":"Br","hidenav":"Cr","indented-menu-link":"Er"};
    if(module.hot) {
      // 1713996741172
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  